import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "../../styles/products/products.css";
import { CartContext } from '../../context/cartcontext.js';

function See_all_newProduct() {
    const [products, setNewProducts] = useState([]);
    const [sortOrder, setSortOrder] = useState("asc");
    const [selectedImages, setSelectedImages] = useState({});
    const { addToCart } = useContext(CartContext);

    useEffect(() => {
        axios.get('https://nurleder.de/api/newProduct/')
            .then(res => {
                const entries = res.data.flatMap(item => item.products || []);
                const filtered = entries.filter(item => item.image);
                setNewProducts(filtered);

                const initialImages = {};
                filtered.forEach(p => initialImages[p.id] = p.image);
                setSelectedImages(initialImages);
            })
            .catch(err => console.error("Fehler beim Laden von newProduct:", err));
    }, []);

    const handleThumbnailClick = (productId, imageUrl) => {
        setSelectedImages(prev => ({
            ...prev,
            [productId]: imageUrl
        }));
    };

    const sortedProducts = [...products].sort((a, b) =>
        sortOrder === "asc" ? a.price - b.price : b.price - a.price
    );

    const getStatusText = (status) => {
        switch (status) {
            case 1:
                return "Vorhanden";
            case 2:
                return "fast Ausverkauft";
            case 3:
                return "Ausverkauft";
            default:
                return "Bestellbar";
        }
    };

    return (
        <section className="product-page">
            <h2>🧵 Frisch gefertigt</h2>

            <div className="sort-container">
                <label>Sortieren:</label>
                <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                    <option value="asc">Aufpreise</option>
                    <option value="desc">Abpreise</option>
                </select>
            </div>

            <div className="grid">
                {sortedProducts.map((product) => (
                    <div key={product.id} className="product-card">
                        <div className="image-wrapper">
                            <img
                                src={selectedImages[product.id] || product.image}
                                alt={product.name}
                                className="main-image"
                            />
                            <div className="thumbnail-row">
                                {[product.image, product.images, product.image2]
                                    .filter(Boolean)
                                    .map((img, i) => (
                                        <img
                                            key={i}
                                            src={img}
                                            alt="thumb"
                                            className={`thumbnail ${selectedImages[product.id] === img ? 'active' : ''}`}
                                            onClick={() => handleThumbnailClick(product.id, img)}
                                        />
                                    ))}
                            </div>
                        </div>

                        <div className="product-info">
                            <p className="name">{product.name}</p>
                            <p className="status">Status: {getStatusText(product.status)}</p>
                            <p className="price">
                                Preise: {parseFloat(product.price).toLocaleString("de-de")} Euro
                            </p>
                            <button className="cart-btn" onClick={() => addToCart(product)}>
                                🛒 in den Warenkorb
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default See_all_newProduct;
